var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-builder-layout"},[_c('main-head-component'),_vm._v(" "),_c('page-builder-slot',_vm._l((_vm.components_data),function(item,index){return _c(item.component_name_kebab,_vm._b({key:`builder-component_${index}`,tag:"component"},'component',item.component_data,false))}),1),_vm._v(" "),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }